import { GetterTree } from 'vuex';
import { ITrackingState } from '@signing-page/tracking/store/tracking.store';
import { IRootState } from '@signing-page/store/store';

export const getterPageViewStopWatchPaused = 'pageViewStopWatchPaused';

export const getters: GetterTree<ITrackingState, IRootState> = {
  [getterPageViewStopWatchPaused](state: ITrackingState): boolean {
    return state.pageViewStopWatchPaused;
  },
};
